import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useTypedAggregatorClient } from '../../aggregator-client-context';
import { CrossProductScope } from './types';
import { messages } from './messages';
import { defaultResultRenderer } from '../../search-result/default-result-renderer';
import { fetchRecentActivities } from './recent-activities';
import { useSearchSessionId } from '../../../common/search-session-provider';
import { useCurrentProductHasAppliedFilters } from '../../filters/filters-helper-functions';
import { filterFirstSectionItems } from '../../product-router/product/result-provider/faster-search-helpers';
export var CROSS_PRODUCT_PRODUCT_ID = 'rovo-cross-product';
var resultRenderer = function resultRenderer(args) {
  return defaultResultRenderer(_objectSpread(_objectSpread({}, args), {}, {
    isCollapsed: true
  }));
};
export var useCrossProductQuerySupplier = function useCrossProductQuerySupplier() {
  var intl = useIntl();
  var aggregatorClient = useTypedAggregatorClient();
  var cloudId = aggregatorClient === null || aggregatorClient === void 0 ? void 0 : aggregatorClient.getAggregatorConfig().cloudId;
  var searchSessionId = useSearchSessionId();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    results = _useState2[0],
    setResults = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isQueryResolved = _useState4[0],
    setIsQueryResolved = _useState4[1];
  var hasFilters = useCurrentProductHasAppliedFilters();
  var preQuerySupplier = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var currentResults, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          currentResults = results;
          if (isQueryResolved) {
            _context.next = 8;
            break;
          }
          _context.next = 4;
          return fetchRecentActivities(cloudId || '', searchSessionId || '');
        case 4:
          response = _context.sent;
          currentResults = response.filter(function (result) {
            return result !== undefined;
          });
          setResults(currentResults);
          setIsQueryResolved(true);
        case 8:
          return _context.abrupt("return", {
            size: currentResults.length,
            sections: [{
              id: CrossProductScope.RECENTS,
              title: intl.formatMessage(messages.cross_product_recents_section_heading),
              searchResults: currentResults,
              resultRenderer: resultRenderer
            }]
          });
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [cloudId, intl, isQueryResolved, results, searchSessionId]);
  var postQuerySupplier = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
      var currentResults, response, searchResults;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            currentResults = results;
            if (isQueryResolved) {
              _context2.next = 8;
              break;
            }
            _context2.next = 4;
            return fetchRecentActivities(cloudId || '', searchSessionId || '');
          case 4:
            response = _context2.sent;
            currentResults = response.filter(function (result) {
              return result !== undefined;
            });
            setResults(currentResults);
            setIsQueryResolved(true);
          case 8:
            searchResults = {
              size: currentResults.length,
              sections: [{
                id: CrossProductScope.RESULTS,
                title: intl.formatMessage(messages.cross_product_results_section_heading),
                searchResults: currentResults,
                resultRenderer: resultRenderer
              }]
            };
            return _context2.abrupt("return", filterFirstSectionItems(searchResults, args.query, hasFilters ? 0 : 3));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [cloudId, intl, isQueryResolved, results, searchSessionId, hasFilters]);
  return {
    preQuerySupplier: preQuerySupplier,
    postQuerySupplier: postQuerySupplier
  };
};